import { Accordion, Box, FormControlLabel, AccordionSummary, Radio, RadioGroup, Typography, IconButton, TextField, Select, MenuItem, Button, InputAdornment } from '@mui/material'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import Loader from '../../../../Components/Loader';
import { localGetItem, localSetItem } from '../../../../Utility/Services/CacheProviderService';
import { CheckAccessFunc } from '../../../../Components/CommonFunctions/CommonFunctions';

class SmsConfig extends Component {
    constructor(props) {
        super(props)
        this.state = {
            OpenEmedhub: true,
            OpenMobileApp: true,
            OpenSmsConfig: true,
            emedhubConfig: {
                "op_bill_sms": false,
                "ip_bill_sms": false,
                "lab_bill_sms": false,
                "pharmacy_bill_sms": false,
                "radiology_bill_sms": false,
                "visit_report_sms": false,
                "prescription_sms": false,
                "appointment_confirmation_sms": false,
                // "appointment_status_update_sms": false,
                "appointment_changed_sms": false,
                "appointment_rescheduled_sms": false,
                "appointment_transferred_sms": false,
                "appointment_token_sms": false,
                "appointment_completed_sms": false,
                "doctor_emergency_sms": false,
                "appointment_canceled_sms": false,
                'future_appointment_sms_reminder':false,
                'followup_sms_reminder':false,
                // "appointment_reminder_sms": false,
                // "appointment_aproximate_time_sms": false,

                // "emed_precription_payment_sms": false,
                // "emed_prescription_order_sms": false,
                "disable_sms_for_walkin_appointments": false,
                "sms_remainder_for_radiotherapy_bills": false,
                "radiotherapy_sms_remainder": false,
                "no_of_days_for_radiotherapy_sms_remainder": "",
                "disable_sms_for_walkin_appointments": false,
            },
            mobileAppConfig: {
                "mobile_prescription_sms": false,
                "mobile_appointment_status_update_sms": false,
                "online_prescription_order_sms": false,
                "precription_payment_sms": false,
                // "telemedicine_appointment_cancel_sms": false,
                // "telemedicine_call_end_sms": false
            },
            whatsappConfig: {
                'lab_report': false,
                'doctor_visit_report': false,
                'appointment_modification': false,
                'appointment_cancellation': false,
                'appointment_rescheduled': false,
                'appointment_transferred': false,
                'future_appointment_reminder': false,
                'appointment_followup_reminder': false,
                'op_invoice': false,
                'ip_invoice': false,
                'lab_invoice': false,
                'pharmacy_invoice': false,
                'radiology_invoice': false,
            },
            thresholdValue: null,
            ShowSmsAlert: false,
            timeInterval: 0,
            id: '',
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: '',
            disableBtn: false,
            isLoader: false,
            sms_limit: 0,
            sms_count: 0,
            whatsappMsg: true,
            ShowwhatsappAlert: false,
            whatsappTHVal: null,
            whatsappInterval: 0,
            whatsappID: null,
        }
    }

    componentDidMount = () => {
        this.getSmsConfiguration()
    }

    assignData = (data) => {
        let states = this.state
        let emedHub = data?.emedhub ? data?.emedhub : {}
        let whatsapp = data?.whatsapp ? data?.whatsapp : {}
        let mobileApp = data?.mobile_app ? data?.mobile_app : {}
        let smsConfig = data?.sms_configuration ? data?.sms_configuration : {}
        let whatsConfig = data?.whatsapp_configurations ? data?.whatsapp_configurations : {} 

        Object.keys(emedHub)?.forEach((item) => {
            states.emedhubConfig[item] = emedHub[item]
        })
        Object.keys(whatsapp)?.forEach((item) => {
            states.whatsappConfig[item] = whatsapp[item]
        })

        states.mobileAppConfig.mobile_prescription_sms = mobileApp?.mobile_prescription_sms
        states.mobileAppConfig.mobile_appointment_status_update_sms = mobileApp?.mobile_appointment_status_update_sms
        states.mobileAppConfig.online_prescription_order_sms = mobileApp?.online_prescription_order_sms
        states.mobileAppConfig.precription_payment_sms = mobileApp?.precription_payment_sms
        // states.mobileAppConfig.telemedicine_appointment_cancel_sms = mobileApp?.telemedicine_appointment_cancel_sms
        // states.mobileAppConfig.telemedicine_call_end_sms = mobileApp?.telemedicine_call_end_sms

        this.setState({
            emedhubConfig: this.state.emedhubConfig,
            mobileAppConfig: this.state.mobileAppConfig,
            thresholdValue: smsConfig?.sms_threshold ? +smsConfig?.sms_threshold : null,
            timeInterval: smsConfig?.threshold_interval ? smsConfig?.threshold_interval : 0,
            ShowSmsAlert: smsConfig?.show_sms_limit_alert ? smsConfig?.show_sms_limit_alert : false,
            id: data?.id ? data?.id : '',
            sms_count: smsConfig?.sms_count ? smsConfig?.sms_count : 0,
            sms_limit: smsConfig?.sms_limit ? smsConfig?.sms_limit : 0,
            isLoader: false,
            whatsapp: this.state.whatsappConfig,
            ShowwhatsappAlert: whatsConfig?.show_sms_limit_alert || false ,
            whatsappTHVal: whatsConfig?.sms_threshold || null,
            whatsappInterval: whatsConfig?.threshold_interval || 0,
            whatsappID: data?.whatsapp_configuration_id
        })
    }

    getSmsConfiguration = () => {
        try {
            this.setState({ isLoader: true })
            RestAPIService.getAllTwo(Serviceurls.FO_SMS_CONFIG)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.assignData(response?.data?.data)
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error?.response?.data?.message)
                    } else {
                        this.errorMessage(error?.message)
                    }
                    this.setState({ isLoader: false })
                })

        } catch (e) {
            this.errorMessage(e?.message)
            this.setState({ isLoader: false })
        }


    }

    handleChange = (item, newValue) => {
        let states = this.state
        item["value"] = newValue;
        this.setState({ states });
    }

    clearData = () => {
        this.getSmsConfiguration()
    }

    postData = () => {
        try {
            let states = this.state
            let data = {
                "id": states.id ? states.id : '',
                "prescription_sms": states.emedhubConfig.prescription_sms,
                "visit_report_sms": states.emedhubConfig.visit_report_sms,
                "appointment_confirmation_sms": states.emedhubConfig.appointment_confirmation_sms,
                // "appointment_status_update_sms": states.emedhubConfig.appointment_status_update_sms,
                "op_bill_sms": states.emedhubConfig.op_bill_sms,
                "ip_bill_sms": states.emedhubConfig.ip_bill_sms,
                "lab_bill_sms": states.emedhubConfig.lab_bill_sms,
                "pharmacy_bill_sms": states.emedhubConfig.pharmacy_bill_sms,
                "radiology_bill_sms": states.emedhubConfig.radiology_bill_sms,
                "appointment_changed_sms": states.emedhubConfig.appointment_changed_sms,
                "appointment_rescheduled_sms": states.emedhubConfig.appointment_rescheduled_sms,
                "appointment_transferred_sms": states.emedhubConfig.appointment_transferred_sms,
                "appointment_token_sms": states.emedhubConfig.appointment_token_sms,
                "appointment_completed_sms": states.emedhubConfig.appointment_completed_sms,
                "doctor_emergency_sms": states.emedhubConfig.doctor_emergency_sms,
                "appointment_canceled_sms": states.emedhubConfig.appointment_canceled_sms,
                // "emed_precription_payment_sms": states.emedhubConfig.emed_precription_payment_sms,
                // "emed_prescription_order_sms": states.emedhubConfig.emed_prescription_order_sms,
                "mobile_prescription_sms": states.mobileAppConfig.mobile_prescription_sms,
                "mobile_appointment_status_update_sms": states.mobileAppConfig.mobile_appointment_status_update_sms,
                "online_prescription_order_sms": states.mobileAppConfig.online_prescription_order_sms,
                "precription_payment_sms": states.mobileAppConfig.precription_payment_sms,
                // "telemedicine_appointment_cancel_sms": states.mobileAppConfig.telemedicine_appointment_cancel_sms,
                // "telemedicine_call_end_sms": states.mobileAppConfig.telemedicine_call_end_sms,
                "sms_threshold": this.state.thresholdValue ? +this.state.thresholdValue : null,
                "threshold_interval": this.state.timeInterval ? +this.state.timeInterval : 0,
                "sms_limit": this.state.sms_limit ? this.state.sms_limit : 0,
                "sms_count": this.state.sms_count ? this.state.sms_count : 0,
                "show_sms_limit_alert": this.state.ShowSmsAlert ? this.state.ShowSmsAlert : false,
                'future_appointment_sms_reminder':states.emedhubConfig?.future_appointment_sms_reminder,
                'followup_sms_reminder':states.emedhubConfig?.followup_sms_reminder,
                "disable_sms_for_walkin_appointments": states.emedhubConfig?.disable_sms_for_walkin_appointments,
                "sms_remainder_for_radiotherapy_bills": states.emedhubConfig?.sms_remainder_for_radiotherapy_bills || false,
                "radiotherapy_sms_remainder": states.emedhubConfig?.radiotherapy_sms_remainder || false,
                "no_of_days_for_radiotherapy_sms_remainder": +states.emedhubConfig?.no_of_days_for_radiotherapy_sms_remainder || 0,
                'whatsapp': {
                    'whatsapp_configuration_id': states.whatsappID,
                    "lab_report": states.whatsappConfig?.lab_report,
                    "doctor_visit_report": states.whatsappConfig?.doctor_visit_report,
                    "appointment_modification": states.whatsappConfig?.appointment_modification,
                    "appointment_cancellation": states.whatsappConfig?.appointment_cancellation,
                    "appointment_rescheduled": states.whatsappConfig?.appointment_rescheduled,
                    "appointment_transferred": states.whatsappConfig?.appointment_transferred,
                    "future_appointment_reminder": states.whatsappConfig?.future_appointment_reminder,
                    "appointment_followup_reminder": states.whatsappConfig?.appointment_followup_reminder,
                    "op_invoice": states.whatsappConfig?.op_invoice,
                    "ip_invoice": states.whatsappConfig?.ip_invoice,
                    "lab_invoice": states.whatsappConfig?.lab_invoice,
                    "pharmacy_invoice": states.whatsappConfig?.pharmacy_invoice,
                    "radiology_invoice": states.whatsappConfig?.radiology_invoice,
                    "sms_threshold": +states?.whatsappTHVal || 0,
                    "threshold_interval": +states?.whatsappInterval || 0,
                    "show_sms_limit_alert": states?.ShowwhatsappAlert
                }
            }
            this.setState({ disableBtn: true })
            RestAPIService.create(data, Serviceurls.FO_SMS_CONFIG)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.successMessage(response?.data?.message)
                        this.getSmsConfiguration()
                        let smsConfig = JSON.stringify(data);
                        localSetItem("smsConfig", smsConfig)
                        const UserData = JSON.parse(localGetItem("loggedInUserInfo"))
                        UserData["whatsapp_config"] = states?.whatsappConfig ? states?.whatsappConfig : UserData?.whatsapp_config
                        UserData["sms_config"] = {
                            ...UserData.sms_config,
                            sms_remainder_for_radiotherapy_bills: states?.emedhubConfig?.sms_remainder_for_radiotherapy_bills || false,
                            radiotherapy_sms_remainder: states?.emedhubConfig?.radiotherapy_sms_remainder || false,
                            no_of_days_for_radiotherapy_sms_remainder: states?.emedhubConfig?.no_of_days_for_radiotherapy_sms_remainder || 0,
                        };
                        localSetItem("loggedInUserInfo", JSON.stringify(UserData))
                        this.setState({ disableBtn: false })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error?.response?.data?.message)
                    } else {
                        this.errorMessage(error?.message)
                    }
                    this.setState({ disableBtn: false })
                })

        } catch (e) {
            this.errorMessage(e?.message)
            this.setState({ disableBtn: false })
        }

    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: '',
        })
    }

    handleRadioChange = (state, key, value) => {
        let states = this.state
        const parsedValue = JSON.parse(value);
        state[key] = parsedValue;
        if (key === "appointment_confirmation_sms" && parsedValue === false) {
            state.disable_sms_for_walkin_appointments = false;
        } else if (key === "radiotherapy_sms_remainder" && parsedValue === false) {
            state.no_of_days_for_radiotherapy_sms_remainder = "";
        }
        this.setState({ states })
    }

    renderRadio = (label, state, key, isDisabled = false) => {
        let value = state[key]
        const hasEditAccess = CheckAccessFunc("front_office", "Settings", 'Message Configuration', "Message Configuration", "SubTab")?.editAccess;
        const disabled = hasEditAccess ? isDisabled : true;
        return (
            <Box sx={{ display: 'flex', justifyContent: 'space-between', m: '0.5vw', ml: '2vw' }}>
                <Typography>{label}</Typography>
                <Box sx={{ display: 'flex', flexDirection: "row" }}>
                    {key === "radiotherapy_sms_remainder" ?
                        <TextField
                            disabled={!value}
                            size='small'
                            value={state?.no_of_days_for_radiotherapy_sms_remainder || ""}
                            onChange={(e) => {
                                if ((CommonValidation.numberOnly(e.target.value) && e.target.value?.length <= 3 && +e.target.value <= 30) || e.target.value === '') {
                                    state.no_of_days_for_radiotherapy_sms_remainder = e.target.value
                                    this.setState({ emedhubConfig: state })
                                }
                                }}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">days</InputAdornment>,
                                }}
                                sx={{ width: "10vw", marginRight:"1vw" }} /> : null}
                        <RadioGroup row sx={{ gap: '2vw', mr: '1vw' }} value={value} onChange={(e) => { this.handleRadioChange(state, key, e.target.value) }}>
                        <FormControlLabel value={true} control={<Radio inputProps={{ 'emed_tid': `${key}_yesBtn_testID` }} disabled={disabled} />} label="Yes" />
                        <FormControlLabel value={false} control={<Radio inputProps={{ 'emed_tid': `${key}_noBtn_testID` }} disabled={disabled} />} label="No" />
                    </RadioGroup>
                </Box>
            </Box>
        )
    }

    render() {
        const { t } = this.props
        let daysOption = []
        for (let i = 1; i <= 7; i++) { daysOption.push(i) }
        const UserData = JSON.parse(localGetItem("loggedInUserInfo"))
        let qmsConfig = UserData?.is_qms_enabled ? UserData?.is_qms_enabled : false
        let WhatsappConfig = UserData?.whatsapp_configuration || false
        let smsConfig = UserData?.sms_config && Object.keys(UserData?.sms_config)?.length > 0 && UserData?.sms_config?.to_send_sms
        return (
            <Box component={'div'} className='eMed_rts_container'>
                <Box component={"div"} height={'78vh'} overflow={'auto'}>
                    {smsConfig ? <Accordion expanded={this.state.OpenEmedhub}>
                        <AccordionSummary sx={{ flexDirection: 'row-reverse' }}
                            expandIcon={
                                <IconButton color='primary' onClick={() => { this.setState({ OpenEmedhub: !this.state.OpenEmedhub }) }} emed_tid="emedhub_expandBtn_testID"><ExpandMoreIcon /></IconButton>}
                        ><Typography fontWeight={'bold'}>eMedHub - SMS</Typography></AccordionSummary>
                        {this.renderRadio("Patient Prescription Report SMS", this.state.emedhubConfig, "prescription_sms")}
                        {this.renderRadio("Doctor Visit Report SMS", this.state.emedhubConfig, "visit_report_sms")}
                        {/* {this.renderRadio("Appointment Status Update SMS", this.state.emedhubConfig, "appointment_status_update_sms")} */}
                        {this.renderRadio("OP Billing SMS", this.state.emedhubConfig, "op_bill_sms")}
                        {this.renderRadio("IP Billing SMS", this.state.emedhubConfig, "ip_bill_sms")}
                        {this.renderRadio("Lab Billing SMS", this.state.emedhubConfig, "lab_bill_sms")}
                        {this.renderRadio("Pharmacy Billing SMS", this.state.emedhubConfig, "pharmacy_bill_sms")}
                        {this.renderRadio("Radiology Billing SMS", this.state.emedhubConfig, "radiology_bill_sms")}
                        {this.renderRadio("Appointment Confirmation SMS", this.state.emedhubConfig, "appointment_confirmation_sms")}
                        {this.renderRadio("Restrict SMS for walk-in appointments", this.state.emedhubConfig, "disable_sms_for_walkin_appointments", this.state.emedhubConfig.appointment_confirmation_sms === false)}
                        {this.renderRadio("Appointment Changed SMS", this.state.emedhubConfig, "appointment_changed_sms")}
                        {this.renderRadio("Appointment Cancelled SMS", this.state.emedhubConfig, "appointment_canceled_sms")}
                        {this.renderRadio("Appointment Completed SMS", this.state.emedhubConfig, "appointment_completed_sms")}
                        {this.renderRadio("Appointment Rescheduled SMS", this.state.emedhubConfig, "appointment_rescheduled_sms")}
                        {this.renderRadio("Appointment Transferred SMS", this.state.emedhubConfig, "appointment_transferred_sms")}
                        {this.renderRadio("Appointment Token SMS", this.state.emedhubConfig, "appointment_token_sms")}
                        {this.renderRadio("Future SMS Appointment Reminder", this.state.emedhubConfig, "future_appointment_sms_reminder")}
                        {this.renderRadio("Followup SMS Reminder", this.state.emedhubConfig, "followup_sms_reminder")}
                        {qmsConfig ? this.renderRadio("Doctor Emergency SMS", this.state.emedhubConfig, "doctor_emergency_sms") : null }
                        {UserData?.enable_radiotherapy ? this.renderRadio("Radiotheraphy - Payment Reminder SMS", this.state.emedhubConfig, "sms_remainder_for_radiotherapy_bills") : null}
                        {UserData?.enable_radiotherapy ? this.renderRadio("Radiotherapy – Outstanding Payment Reminder SMS (Enter reminder interval in days)", this.state.emedhubConfig, "radiotherapy_sms_remainder") : null}
                        {/* {this.renderRadio("Patient Prescription Payment SMS", this.state.emedhubConfig, "emed_precription_payment_sms")} */}
                        {/* {this.renderRadio("Online Prescription Order SMS", this.state.emedhubConfig, "emed_prescription_order_sms")} */}
                    </Accordion> : null}
                    {/* <Accordion expanded={this.state.OpenMobileApp}> // Comment mobile app for future usage
                        <AccordionSummary sx={{ flexDirection: 'row-reverse' }}
                            expandIcon={
                                <IconButton color='primary' onClick={() => { this.setState({ OpenMobileApp: !this.state.OpenMobileApp }) }} emed_tid="mobileApp_expandBtn_testID"><ExpandMoreIcon /></IconButton>}
                        ><Typography fontWeight={'bold'}>Mobile App</Typography></AccordionSummary>
                        {this.renderRadio("Prescription Transmission SMS", this.state.mobileAppConfig, "mobile_prescription_sms")}
                        {this.renderRadio("Appointment Status Notification SMS", this.state.mobileAppConfig, "mobile_appointment_status_update_sms")}
                        {this.renderRadio("Online Prescription Order Status SMS", this.state.mobileAppConfig, "online_prescription_order_sms")}
                        {this.renderRadio("Prescription Payment Confirmation SMS", this.state.mobileAppConfig, "precription_payment_sms")}
                        {this.renderRadio("Telemedicine Appointment Cancellation SMS", this.state.mobileAppConfig, "telemedicine_appointment_cancel_sms")}
                        {this.renderRadio("Telemedicine Call Ended SMS", this.state.mobileAppConfig, "telemedicine_call_end_sms")}
                    </Accordion> */}
                    {smsConfig ? <Accordion expanded={this.state.ShowSmsAlert}>
                        <AccordionSummary sx={{ flexDirection: 'row-reverse' }}
                        >
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', m: '0.5vw', alignItems:'center',width:"100%" }}>
                                <Typography fontWeight={'bold'}>{"Show SMS Limit Reached alert"}</Typography>
                                <RadioGroup row sx={{ gap: '2vw', mr: '1vw' }} value={this.state.ShowSmsAlert} onChange={(e) => {
                                    this.setState({
                                        ShowSmsAlert: JSON.parse(e.target.value)
                                    })
                                }}>
                                    <FormControlLabel value={true} control={<Radio inputProps={{ 'emed_tid': `${"ShowSmsAlert"}_yesBtn_testID` }} disabled={!CheckAccessFunc("front_office", "Settings", 'Message Configuration', "Message Configuration", "SubTab")?.editAccess} />} label="Yes" />
                                    <FormControlLabel value={false} control={<Radio inputProps={{ 'emed_tid': `${"ShowSmsAlert"}_noBtn_testID` }} disabled={!CheckAccessFunc("front_office", "Settings", 'Message Configuration', "Message Configuration", "SubTab")?.editAccess} />} label="No" />
                                </RadioGroup>
                            </Box>
                        </AccordionSummary>
                        <Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', m: '0.5vw', ml: '2vw', mr: '1vw' }}>
                                <Typography>Threshold For SMS</Typography>
                                <TextField
                                    label='Threshold Value'
                                    size='small'
                                    autoComplete='off'
                                    sx={{ width: '15vw' }}
                                    inputProps={{ emed_tid: "thresholdValue_testID", maxLength: 30 }}
                                    value={this.state.thresholdValue ? this.state.thresholdValue : ""}
                                    disabled={!CheckAccessFunc("front_office", "Settings", 'Message Configuration', "Message Configuration", "SubTab")?.editAccess}
                                    onChange={(e) => {
                                        if (CommonValidation.numberOnly(e.target.value) || e.target.value === '') {
                                            this.setState({ thresholdValue: e.target.value })
                                        }
                                    }}
                                />
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', m: '0.5vw', ml: '2vw', mr: '1vw' }}>
                                <Typography>Time Interval</Typography>
                                <Box component={'div'}>
                                    <Select
                                        sx={{ width: '10vw', fontSize: '0.95vw' }}
                                        size='small'
                                        value={this.state.timeInterval}
                                        onChange={(e) => { this.setState({ timeInterval: e.target.value }) }}
                                        inputProps={{ emed_tid: 'timeInterval_testID' }}
                                        disabled={!CheckAccessFunc("front_office", "Settings", 'Message Configuration', "Message Configuration", "SubTab")?.editAccess}
                                    >
                                        <MenuItem sx={{ fontSize: '0.95vw' }} value={0}>Select Interval</MenuItem>
                                        {daysOption.map((list) => (
                                            <MenuItem sx={{ fontSize: '0.95vw' }} key={list} value={list}>{list}</MenuItem>
                                        ))}
                                    </Select>
                                    <TextField size='small' value={"Days"} sx={{ width: '5vw' }} inputProps={{ emed_tid: 'timeInterval_days_testID' }} disabled={true} />
                                </Box>
                            </Box>

                        </Box>
                    </Accordion>   : null}

                    {/* Whatsapp Message Container */}
                    {WhatsappConfig ? <Accordion expanded={this.state.whatsappMsg}>
                        <AccordionSummary sx={{ flexDirection: 'row-reverse' }}
                            expandIcon={
                                <IconButton color='primary' onClick={() => { this.setState({ whatsappMsg: !this.state.whatsappMsg }) }} emed_tid="emedhub_expandBtn_testID"><ExpandMoreIcon /></IconButton>}
                        ><Typography fontWeight={'bold'}>eMedHub - Whatsapp</Typography></AccordionSummary>
                        {this.renderRadio("Lab Report ", this.state.whatsappConfig, "lab_report")}
                        {this.renderRadio("Doctor Visit Report", this.state.whatsappConfig, "doctor_visit_report")}
                        {this.renderRadio("OP Invoice", this.state.whatsappConfig, "op_invoice")}
                        {this.renderRadio("IP Invoice", this.state.whatsappConfig, "ip_invoice")}
                        {this.renderRadio("Lab Invoice", this.state.whatsappConfig, "lab_invoice")}
                        {this.renderRadio("Pharmacy Invoice", this.state.whatsappConfig, "pharmacy_invoice")}
                        {this.renderRadio("Radiology Invoice", this.state.whatsappConfig, "radiology_invoice")}
                        {this.renderRadio("Appointment Modification", this.state.whatsappConfig, "appointment_modification")}
                        {this.renderRadio("Appointment Cancellation", this.state.whatsappConfig, "appointment_cancellation")}
                        {this.renderRadio("Appointment Rescheduled", this.state.whatsappConfig, "appointment_rescheduled")}
                        {this.renderRadio("Appointment Transferred", this.state.whatsappConfig, "appointment_transferred")}
                        {this.renderRadio("Future Appointment Reminder", this.state.whatsappConfig, "future_appointment_reminder")}
                        {this.renderRadio("Appointment Followup Reminder", this.state.whatsappConfig, "appointment_followup_reminder")}
                    </Accordion> : null}
                    {WhatsappConfig ? <Accordion expanded={this.state.ShowwhatsappAlert}>
                        <AccordionSummary sx={{ flexDirection: 'row-reverse' }}
                        >
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', m: '0.5vw', alignItems: 'center', width: "100%" }}>
                                <Typography fontWeight={'bold'}>{"Show Whatsapp Message Limit Reached alert"}</Typography>
                                <RadioGroup row sx={{ gap: '2vw', mr: '1vw' }} value={this.state.ShowwhatsappAlert} onChange={(e) => {
                                    this.setState({
                                        ShowwhatsappAlert: JSON.parse(e.target.value)
                                    })
                                }}>
                                    <FormControlLabel value={true} control={<Radio inputProps={{ 'emed_tid': `${"ShowwhatsappAlert"}_yesBtn_testID` }} disabled={!CheckAccessFunc("front_office", "Settings", 'Message Configuration', "Message Configuration", "SubTab")?.editAccess} />} label="Yes" />
                                    <FormControlLabel value={false} control={<Radio inputProps={{ 'emed_tid': `${"ShowwhatsappAlert"}_noBtn_testID` }} disabled={!CheckAccessFunc("front_office", "Settings", 'Message Configuration', "Message Configuration", "SubTab")?.editAccess} />} label="No" />
                                </RadioGroup>
                            </Box>
                        </AccordionSummary>
                        <Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', m: '0.5vw', ml: '2vw', mr: '1vw' }}>
                                <Typography>Threshold For Whatsapp Message</Typography>
                                <TextField
                                    label='Threshold Value'
                                    size='small'
                                    autoComplete='off'
                                    sx={{ width: '15vw' }}
                                    inputProps={{ emed_tid: "whatsappTHVal_testID", maxLength: 30 }}
                                    value={this.state.whatsappTHVal ? this.state.whatsappTHVal : ""}
                                    disabled={!CheckAccessFunc("front_office", "Settings", 'Message Configuration', "Message Configuration", "SubTab")?.editAccess}
                                    onChange={(e) => {
                                        if (CommonValidation.numberOnly(e.target.value) || e.target.value === '') {
                                            this.setState({ whatsappTHVal: e.target.value })
                                        }
                                    }}
                                />
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', m: '0.5vw', ml: '2vw', mr: '1vw' }}>
                                <Typography>Time Interval</Typography>
                                <Box component={'div'}>
                                    <Select
                                        sx={{ width: '10vw', fontSize: '0.95vw' }}
                                        size='small'
                                        value={this.state.whatsappInterval}
                                        onChange={(e) => { this.setState({ whatsappInterval: e.target.value }) }}
                                        inputProps={{ emed_tid: 'whatsappInterval_testID' }}
                                        disabled={!CheckAccessFunc("front_office", "Settings", 'Message Configuration', "Message Configuration", "SubTab")?.editAccess}
                                    >
                                        <MenuItem sx={{ fontSize: '0.95vw' }} value={0}>Select Interval</MenuItem>
                                        {daysOption.map((list) => (
                                            <MenuItem sx={{ fontSize: '0.95vw' }} key={list} value={list}>{list}</MenuItem>
                                        ))}
                                    </Select>
                                    <TextField size='small' value={"Days"} sx={{ width: '5vw' }} inputProps={{ emed_tid: 'whatsappInterval_days_testID' }} disabled={true} />
                                </Box>
                            </Box>

                        </Box>
                    </Accordion> : null}
                    <Box sx={{ display: 'flex', gap: '1vw', m: '2vw', display: 'flex', justifyContent: 'flex-end' }}>
                        <Button variant='outlined' emed_tid='smsConfig_clearBtn_testID' onClick={this.clearData} disabled={!CheckAccessFunc("front_office", "Settings", 'Message Configuration', "Message Configuration", "SubTab")?.editAccess}>Clear</Button>
                        <Button variant='contained' emed_tid='smsConfig_SaveBtn_testID' disabled={!CheckAccessFunc("front_office", "Settings", 'Message Configuration', "Message Configuration", "SubTab")?.editAccess ? true : this.state.disableBtn} onClick={this.postData}>Save</Button>
                    </Box>
                </Box>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                <Loader loaderOpen={this.state.isLoader} />
            </Box>
        )
    }
}

export default withTranslation()(SmsConfig)